import MediumHeader from "../UI/textFields/MediumHeader";
import StandardButton from "../UI/buttons/StandardButton";
import { Spinner } from "../UI/Spinner";
import labels from "../../utils/labels";
import dateUtil from "../../utils/dateUtil";
import { RunInProgress } from "../../types/nexusLanding";

// Zero-based index of the step that is currently running
const CURRENT_STEP_BY_STAGE: Record<RunInProgress["stage"], number> = {
  FETCHING: 0,
  OPTIMIZING: 2,
};

const RunInProgressDialog = ({
  runInProgress,
  stage,
  filterName,
  date,
  isStarting,
  onFollowClick,
  onStopAndRestartClick,
}: {
  runInProgress: RunInProgress;
  stage: RunInProgress["stage"];
  filterName: string;
  date: string;
  isStarting: boolean;
  onFollowClick: () => void;
  onStopAndRestartClick: () => void;
}) => {
  const steps = [
    labels.nexusLandingStepFetching,
    labels.nexusLandingStepNexusReady,
    labels.nexusLandingStepCalculating,
    labels.nexusLandingStepDone,
  ];
  const currentStep = CURRENT_STEP_BY_STAGE[stage];

  return (
    <div className="RunInProgressDialog fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-[620px]">
        <MediumHeader classes={"pb-2"}>
          {labels.nexusLandingRunInProgressHeader}
        </MediumHeader>
        <div className="border rounded-lg p-3 mb-3">
          <p className="bodyTwo font-bold">{`${filterName} · ${date}`}</p>
          <p className="bodyTwo pb-2">
            {labels.nexusLandingRunInProgressStartedAt(
              dateUtil.formatClockTime(runInProgress.startedAt),
              runInProgress.startedByName,
            )}
          </p>
          <ol className="flex flex-row gap-4">
            {steps.map((step, index) => (
              <li
                key={step}
                aria-current={index === currentStep ? "step" : undefined}
                className={
                  index === currentStep
                    ? "bodyTwo font-bold"
                    : index < currentStep
                      ? "bodyTwo"
                      : "bodyTwo opacity-50"
                }
              >
                {`${index < currentStep ? "✓ " : ""}${step}`}
              </li>
            ))}
          </ol>
        </div>
        <p className={"bodyTwo pb-3"}>{labels.nexusLandingRunInProgressBody}</p>
        <div className={"flex flex-row justify-end"}>
          <StandardButton
            variant={"SECONDARY"}
            classes={"mr-6"}
            onClick={onStopAndRestartClick}
            disable={isStarting}
            ariaLabel={labels.nexusLandingRunInProgressStopAndRestart}
          >
            {isStarting ? (
              <span className="flex items-center gap-2">
                <Spinner width={20} height={20} />
                {labels.nexusLandingPageStartingImport}
              </span>
            ) : (
              labels.nexusLandingRunInProgressStopAndRestart
            )}
          </StandardButton>
          <StandardButton
            variant={"PRIMARY"}
            onClick={onFollowClick}
            disable={isStarting}
            ariaLabel={labels.nexusLandingRunInProgressFollow}
          >
            {labels.nexusLandingRunInProgressFollow}
          </StandardButton>
        </div>
      </div>
    </div>
  );
};

export default RunInProgressDialog;
